<template>
	<div>
		<div :id="id" class="center-modal modal bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
		  <div class="modal-dialog modal-lg">
		    <div class="modal-content">
			    <div class="modal-header">
		          <button v-if="is_close && is_close != undefined " type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="closeModal()">&times;</button>
		          <h4 class="modal-title">{{ title }}</h4>
		        </div>
			    <div class="modal-body overflow-x-auto">
	        		<slot></slot>
			    </div>
		    </div>
		    <footer>
			    <slot name="footer"></slot>
			</footer>
		  </div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "centerModalWidget",
		props: [
			'id', 'title', 'is_close'
		],
		data: function(){
			return {
				is_show_modal: false
			}
		},
		methods: {
			openModal(){
				var app = this;
        $('#'+app.id).modal('show');
		        app.is_show_modal = true;
			},
			closeModal(){
				var app = this;
				$('#'+app.id).modal('hide');
				app.is_show_modal = false;
			},
		},
		mounted: function(){
		}
	}
</script>

<style>
.center-modal.modal{
	z-index: 9999;
}
.center-modal .modal-dialog{
	margin: 6rem auto;
}
.center-modal .modal-header{
	border-bottom: 1px solid #1b486e !important;
}
.center-modal .modal-body{
	min-height: 350px !important;
}
</style>